import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LAST_ADMIN_ROUTE_KEY } from '../../constants/adminNavigation';
import './AdminLayout.css';
import { useAdminAccess } from '../../context/AdminAccessContext';

const AdminLayout = ({ title, description, actions, children }) => {
  const { logout } = useAdminAccess();

  const navLinks = [
    { to: '/admin/services', label: 'Services' },
    { to: '/admin/testimonials', label: 'Testimonials' },
    { to: '/admin/portfolios', label: 'Portfolios' },
    { to: '/admin/blogs', label: 'Blogs' },
    { to: '/admin/blog-topics', label: 'Blog Topics' },
    { to: '/admin/contact-queries', label: 'Contact Inquiries' },
    { to: '/admin/quote-requests', label: 'Quote Requests' },
    { to: '/admin/settings', label: 'Settings' }
  ];

  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (location.pathname.startsWith('/admin')) {
      window.localStorage.setItem(LAST_ADMIN_ROUTE_KEY, location.pathname);
    }
  }, [location.pathname]);

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">IFStatic Admin</div>
        <nav className="admin-nav">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="admin-content">
        <header className="admin-header">
          <div>
            <h1>{title}</h1>
            {description && <p>{description}</p>}
          </div>
          <div className="admin-header-actions">
            {actions}
            <button type="button" className="admin-logout-btn" onClick={logout}>
              Log out
            </button>
          </div>
        </header>

        <section className="admin-body">{children}</section>
      </main>
    </div>
  );
};

export default AdminLayout;
